import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import usePrimeVue from './plugins/prime-vue'
import useInternalization from './plugins/i18n'
import { useTheme } from './modules/shared/composable/useTheme'
import { registerServiceWorker } from './modules/pwa/composable/usePwaUpdate'
import { listenForInstallPrompt } from './modules/pwa/composable/useInstallPrompt'

const app = createApp(App)

app.use(createPinia())
usePrimeVue(app)
useInternalization(app)
app.use(router)

// Resolved before the first paint, not on the first component that happens to
// ask. It used to be called only from AppLayout — and the LOGIN screen sits
// outside that layout, so someone who chose dark was handed a white login page
// every single time, under indigo browser chrome.
useTheme()

// Registered at startup for the same reason the theme is: the LOGIN screen sits
// outside AppLayout, and that is where somebody lands BEFORE they have an
// account open — the exact moment a browser would offer to install the app.
// Registered only from the authenticated shell, there was no service worker on
// that page, so no browser ever offered it.
registerServiceWorker()

// Captured at startup because `beforeinstallprompt` fires once, early, and is
// gone before any component mounts. Chrome on Android stopped offering
// installation by itself; this keeps the offer so the APP can make it.
listenForInstallPrompt()

app.mount('#app')
